import { render, staticRenderFns } from "./OrderReturnStatus.vue?vue&type=template&id=44e1276f"
import script from "./OrderReturnStatus.vue?vue&type=script&lang=js"
export * from "./OrderReturnStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports